import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Api } from "../../services/api";

const FinancialControllerDashboard = ({typeOfData}) => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    const [projects, setProjects] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState(null);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            first_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

        });
        setGlobalFilterValue('');
    };


    /** search Filtter function End */

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue} onChange={onGlobalFilterChange}
                    // onChange={(e) => searchproject(e.target.value)}
                    placeholder="Search..."
                />
            </span>
        </div>
    );


    useEffect(() => {
        getProjectDetails();
        initFilters();
        return () => {

        };
    }, []);

    const getProjectDetails = () => {

        // /+typeOfData

        fetch(Api.API_BASE_URL + 'financial-controller/get-all', {
            method: "GET",
        })
            .then((response) => response.json())
            .then((response) => {

                setProjects(response.result);
                setIsLoading(false);

            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);

            });
    }

  


 

    const edit = (rowData) => {
        console.log(rowData);
        navigate('/ac-fa-controller/view/' + rowData.user_id+'/'+rowData.role_id);
       
    }



    return (
        <> 
        <Toast ref={toast} />
            <ConfirmDialog />
            <div className="one-line-container">

            </div>
            {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

            <div className="pagee-container">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                    <TabPanel header="" className="p-2 pb-2" >
                        <div className=" m-0" style={{ width: "100%" }} >
                       
                            <DataTable value={projects} paginator rows={10} dataKey="id" selection={selectedProduct}  onSelectionChange={(e) => edit(e.value)} 
                             selectionMode="single" header={header} filters={filters} globalFilterFields={['date', 'month','month', 'first_name', 'last_name']}  >
                              
                                <Column  header="Name" body={(e)=> <span>{e.first_name+' '+e.last_name}</span>} className="h-3rem" ></Column>
                                <Column field="date" header="Date" className="h-3rem" ></Column>
                                <Column field="month" header="Month" ></Column>
                                <Column field="year" header="Year" ></Column>
                               
                             
                            </DataTable>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
            )}
        </>
    )
}

export default FinancialControllerDashboard;